import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem, SubMenu, sidebarClasses } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import {MdPreview} from "react-icons/md";
import "./AdminNav.css";
import {
  UserRoundCog,
  Gauge,
  BookOpenCheck,
  UserRound,
  Briefcase,
  HandCoins,
  Percent,
  PersonStanding,
  Wrench,
  Handshake,
  Building2,
  ReceiptText,
  HandHelping,
  ShieldAlert,
  MapPinned,
  Navigation,
  WalletCards,
  PackageSearch,
  NotebookTabs,
  Split,
  BriefcaseBusiness,
  Waypoints,
  FileClock,
  Layers3,
  LayoutList,
  Spline,
  Logs,
  Activity,
  HeartPulse,
  LandPlot,
  CalendarCheck2,
  House,
  GroupIcon,
  CompassIcon,
  User2Icon,
} from "lucide-react";
// import CCS from '../images/CCS.png';
// import shortLogo from '../images/shortLogo.png';
import logoImg from "../../assets/image/VAP-logoTR.png";
import  FaCartArrowDown  from "@react-icons/all-files/fa/FaCartArrowDown";
import  {MdHighQuality}  from "react-icons/md";
// const applink = "https://1713-vancouver-auto-parts-854202032.development.catalystserverless.com/app/index.html"
const applink = process.env.REACT_APP_APPLINK;
function AdminNav(props) {
  const location = useLocation();
  const [logo, setLogo] = useState(true);
  useEffect(() => {
    setLogo(!logo);
  }, [props.isSidebarCollapsed]);
  const customMenuItemStyles = {
    button: {
      color: "#00000",
      paddingLeft: 0,
    },
    psMenuButton: {
      marginLeft: "0px !important",
      height: "40px !important",
    },
  };

  const salesmenu=[
    "/admin/order-list",
    "/admin/customer-list" 
  ];

  const  productmenu=[
    "/admin/product-list",
    "/admin/mapping-middleware" ,
    "/admin/pricing-list",
    "/admin/collection",
    "/admin/brand-master" ,
    "/admin/product-review"
  ];
  const purchaseMenu=[
    "/admin/purchaseOrder-list" ,
    "/admin/vendor-list" 
  ];
  const webPanelMenu=[
    "/admin/add-category" ,
    "/admin/add-blog" 
  ]

  return (
    <div style={{ height: "100vh" }} className="d-none d-sm-block">
      <Sidebar
        collapsed={props.isSidebarCollapsed}
        width="200px"
        collapsedWidth="40px"
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "#034C8C",
            color: "white",
            minHeight: "100vh",
          },
        }}
      >
        <Menu menuItemStyles={customMenuItemStyles}>
          <div className="logo-div">
            {!logo ? (
              <span className="mx-1 my-2">
                <img src={logoImg} />
              </span>
            ) : (
              <span className="">{/* <img src={logoImg} alt='logo' /> */}</span>
            )}
          </div>
          <div className="custom-scroll" style={{ maxHeight: "90vh" }}>
            <MenuItem icon={<House size={20} />} component={<Link to="/admin/dashboard" />} className={location.pathname === "/admin/dashboard" ? "menu-item active" : "menu-item"}>
              Home
            </MenuItem>

            <SubMenu  className={`text-white ${salesmenu.includes(location.pathname) ? "subMenu active" : "subMenu"} `}  label="Sales"  icon={<HandCoins size={20} />}>
              <MenuItem icon={<WalletCards size={20} />} component={<Link to="/admin/order-list" />} className={location.pathname === "/admin/order-list" ? "menu-item active" : "menu-item"}>
                Orders
              </MenuItem>
              <MenuItem icon={<UserRoundCog size={20} />} component={<Link to="/admin/customer-list" />} className={location.pathname === "/admin/customer-list" ? "menu-item active" : "menu-item"}>
                Customers
              </MenuItem>
            </SubMenu> 
            <SubMenu  className={`text-white  ${productmenu.includes(location.pathname) ? "subMenu active" : "subMenu"}`}
                 label="Products" icon={<UserRoundCog size={20} />}>
              {/* <MenuItem icon={<FaCartArrowDown size={20} />} component={<Link to="/admin/product-list" />} className={location.pathname === "/admin/product-list" ? "menu-item active" : "menu-item"}>
                Products
              </MenuItem> */}
              <MenuItem icon={<MdPreview size={20} />} component={<Link to="/admin/mapping-middleware" />} className={location.pathname === "/admin/mapping-middleware" ? "menu-item active" : "menu-item"}>
                Mapping Middleware
              </MenuItem>
              <MenuItem icon={<MdPreview size={20} />} component={<Link to="/admin/pricing-list" />} className={location.pathname === "/admin/pricing-list" ? "menu-item active" : "menu-item"}>
                Pricing List
              </MenuItem>
              {/* <MenuItem icon={<GroupIcon size={20} />} component={<Link to="/admin/collection" />} className={location.pathname === "/admin/collection" ? "menu-item active" : "menu-item"}>
                Category
              </MenuItem> */}
              {/* <MenuItem icon={<CompassIcon size={20} />} component={<Link to="/admin/brand-master" />} className={location.pathname === "/admin/brand-master" ? "menu-item active" : "menu-item"}>
                Brand Master
              </MenuItem> */}
              <MenuItem icon={<MdPreview size={20} />} component={<Link to="/admin/product-review" />} className={location.pathname === "/admin/product-review" ? "menu-item active" : "menu-item"}>
                Product Review
              </MenuItem>

            </SubMenu>
            {/* <SubMenu className={`text-white  ${purchaseMenu.includes(location.pathname) ? "subMenu active" : "subMenu"}`} label="Purchase Orders" icon={<HandCoins size={20} />}>
              <MenuItem
                icon={<WalletCards size={20} />}
                component={<Link to="/admin/purchaseOrder-list" />}
                className={location.pathname === "/admin/purchaseOrder-list" ? "menu-item active" : "menu-item"}
              >
                Purchase Orders
              </MenuItem>
              <MenuItem
                icon={<User2Icon size={20} />}
                component={<Link to="/admin/vendor-list" />}
                className={location.pathname === "/admin/vendor-list" ? "menu-item active" : "menu-item"}
              >
                Vendor
              </MenuItem>
            </SubMenu> */}

            {/* <MenuItem icon={<NotebookTabs size={20} />} component={<Link to="/admin/tag-master" />} className={location.pathname === "/admin/tag-master" ? "menu-item active" : "menu-item"}>
              Tag Master
            </MenuItem> */}
            <a href="https://www.vancouverautoparts.ca/app/#/shop" target="_blank" rel="noopener noreferrer">
              <MenuItem className=" hover:text-black" icon={<LayoutList size={20} />}>Online Store</MenuItem>
            </a>

            <SubMenu className={`text-white  ${webPanelMenu.includes(location.pathname) ? "subMenu active" : "subMenu"}`} label="Website Panel"  icon={<HandCoins size={20} />}>
              <MenuItem icon={<WalletCards size={20} />} component={<Link to="/admin/add-category" />} className={location.pathname === "/admin/add-category" ? "menu-item active" : "menu-item"}>
                Blog Category
              </MenuItem>
              <MenuItem icon={<WalletCards size={20} />} component={<Link to="/admin/add-blog" />} className={location.pathname === "/admin/add-blog" ? "menu-item active" : "menu-item"}>
                Blog
              </MenuItem>
            </SubMenu>
          </div>
        </Menu>
      </Sidebar>
    </div >
  );
}

export default AdminNav;
